import styled, { css } from 'styled-components'
import CustomLink from '../../../../components/CustomLink'
import { RecommendedArticleItemContentWrapperBaseStyle, RecommendedArticleWrapperBaseStyle } from '../styled'
import { RecommendedArticleAssetComponentProps } from '../../types'
import { getBreakPoint } from '../../../../lib/styles/breakpoints'

export const NewsTeaserMedia = styled.img<RecommendedArticleAssetComponentProps>`
  display: block;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  overflow: hidden;

  @media screen and (max-width: 576px) {
    width: ${({ $isSmall }) => !$isSmall && '100%'};
  }
`
export const NewsTeaserMediaWrapper = styled.picture<RecommendedArticleAssetComponentProps>`
  overflow: hidden;
  border-radius: ${({ $isSmall }) => ($isSmall ? `0.5rem` : `0.7rem`)};
  border: solid 1px ${({ theme }) => theme.colors.black[6]};
  ${({ $isSmall }) =>
    $isSmall
      ? css`
          height: 3.5rem;
          width: 6.2rem;
        `
      : css`
          height: auto;
          flex: 1 1 40%;
        `};
`
export const NewsTeaserComponentWrapper = styled(CustomLink)<RecommendedArticleAssetComponentProps>`
  ${RecommendedArticleWrapperBaseStyle};

  padding: 0.5rem;
  gap: 0.5rem;

  &:hover,
  &:focus-visible {
    img {
      transform: scale(1.1);
    }
  }

  @media (${getBreakPoint('sm')}) {
    padding-bottom: ${({ $isSmall }) => !$isSmall && '2rem'};
    gap: ${({ $isSmall }) => $isSmall && '1rem'};
  }
`

export const NewsTeaserContentWrapper = styled.div<RecommendedArticleAssetComponentProps>`
  ${RecommendedArticleItemContentWrapperBaseStyle};
  padding: ${({ $isSmall }) => ($isSmall ? '0.5rem' : '1rem ')};
`
